export default function SliderInput({
  label,
  name,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  formatValue,
}) {
  const display = formatValue ? formatValue(value) : value;

  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <div className="slider-wrap">
        <span className="slider-value">{display}</span>
        <input
          type="range"
          name={name}
          min={min}
          max={max}
          step={step}
          value={value ?? min}
          onChange={onChange}
        />
      </div>
    </label>
  );
}
